import * as notificationConstants from '../notificationConstants';

import {navigationConstants} from '../../Navigation';
import {removeToastMessageReducer} from './removeToastMessageReducer';
import {saveToastMessageReducer} from './saveToastMessageReducer';


const INITIAL_STATE = {
    toastMessages: []
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {


        case navigationConstants.ACTION_ROUTE_CHANGE:

            return removeToastMessageReducer(state, null);


        case notificationConstants.ACTION_TOAST_MESSAGE:

            return saveToastMessageReducer(state, action.payload);


        case notificationConstants.ACTION_TOAST_MESSAGE_REMOVE:

            return removeToastMessageReducer(state, action.payload);


        default:

            return state;
    }

};
